"use strict";
exports.__esModule = true;
//# sourceMappingURL=notes.type.js.map